import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Numbers } from '../../../../helpers';
import HomeService from '../../../../services/Home';
import { MainTitle, SecondaryTitle } from './styles/TitleStyled';
import useOtherLines from '../../../../hooks/useOtherLines';

const Title = ({ segment, cellphone }) => {
  const [isLoading, setLoading] = useState(true);
  const [isError, setError] = useState(false);
  const [balance, setBalance] = useState(0);
  const postpaidSegment = segment.toUpperCase() === 'POSTPAID';
  const showBalance = !isLoading && !isError && !postpaidSegment;

  useEffect(() => {
    if (!postpaidSegment) {
      HomeService.getBalance()
        .then(res => {
          const [{ balance: balanceDetails }] = res;
          setBalance(balanceDetails.total);
        })
        .catch(() => {
          setError(true);
        })
        .then(() => {
          setLoading(false);
        });
    }
  }, []);

  const { isOtherLines } = useOtherLines();

  if (isOtherLines) return false;

  return (
    <div>
      <SecondaryTitle>Estás comprando una bolsa para</SecondaryTitle>
      <MainTitle>
        {`+${cellphone.replace(
          /(\d{2})\D?(\d{1})\D?(\d{4})\D?(\d{4})/,
          '$1 $2 $3 $4'
        )}`}
      </MainTitle>
      {showBalance && (
        <SecondaryTitle>
          Su Saldo
          <span>{` $${Numbers.addThousandSeparators(balance)}`}</span>
        </SecondaryTitle>
      )}
    </div>
  );
};

Title.propTypes = {
  segment: PropTypes.string.isRequired,
  cellphone: PropTypes.string.isRequired,
};

export default Title;
